import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import withHostContext from '../../context/host/consumer';
import Profile from '../ProfilesMenu/Profile';
import PodBanner from '../../components/PodBanner';
import JobPlacementRate from './JobPlacementRate';
import StudentFacultyRatio from './StudentFacultyRatio';
import StudentRetention from './StudentRetention';
import AverageClassSize from './AverageClassSize';
import DegreesOffered from './DegreesOffered';
import Placement from './Placement';
import MajorsMinors from './MajorsMinors';
import StudyOptions from './StudyOptions';
import TopAreasOfStudy from './TopAreasOfStudy';
import { groupMajors } from '../../utils/collections';

import { ONLINE_ALL_PROGRAMS, ONLINE_SOME_PROGRAMS } from '../../constants';

class StudiesMenu extends React.PureComponent {
  static propTypes = {
    profile: PropTypes.shape({
      custom_profiles: PropTypes.array,
    }),
    collegeName: PropTypes.string,
    studiesData: PropTypes.object,
    lastUpdated: PropTypes.string,
    getDegreesOfferedFilter: PropTypes.func,
    setDegreesOfferedFilter: PropTypes.func,
  };

  render() {
    const {
      collegeName,
      studiesData = {},
      lastUpdated,
      getDegreesOfferedFilter,
      setDegreesOfferedFilter,
      hostContext,
    } = this.props;
    const profile = this.props.profile || {};
    const programProfiles = []
      .concat(profile.custom_profiles || [])
      .filter((pr) => pr && pr.type === 'program');
    const facultyProfiles = []
      .concat(profile.custom_profiles || [])
      .filter((pr) => pr && pr.type === 'faculty');
    const lessThan1Year = get(studiesData, 'jobPlacementRate.lessThan1Year.value');
    const lessThan6Months = get(studiesData, 'jobPlacementRate.lessThan6Months.value');
    const studentFacultyRatio = get(studiesData, 'studentFacultyRatio.value');
    const studentRetentionValue = get(studiesData, 'studentRetention.value');
    const averageClassSize = get(studiesData, 'avgClassSize.value');
    const majors = get(studiesData, 'majors', []);
    const lastUpdatedMajor = get(studiesData, 'lastUpdatedMajor');
    const minors = get(studiesData, 'minors', []);
    const programsOnline = [ONLINE_SOME_PROGRAMS, ONLINE_ALL_PROGRAMS].includes(
      get(studiesData, 'programsOnline.value', ''),
    );
    const placement = get(studiesData, 'placement');
    const topAreasOfStudy = get(studiesData, 'topAreasOfStudy', null);
    const isStarfishClient = get(studiesData, 'isStarfishClient.value', false);
    const studyOptions = get(studiesData, 'studyOptions', {});
    const isCamino = get(hostContext, 'isCamino', false);
    const topAreasOfStudyTitle = isCamino && get(hostContext, 'topAreasOfStudyTitle');
    return (
      <div className="studies-menu-container common-full-width">
        <PodBanner>
          <StudentFacultyRatio
            facultyRatio={studentFacultyRatio ? `${studentFacultyRatio}:1` : null}
            lastUpdated={lastUpdated}
          />
          <AverageClassSize
            averageClassSize={Number(averageClassSize)}
            lastUpdated={lastUpdated}
          />
          <StudentRetention
            studentRetentionValue={studentRetentionValue}
            isStarfishClient={isStarfishClient}
            lastUpdated={lastUpdated}
          />
          <JobPlacementRate
            lessThan6Months={lessThan6Months}
            lessThan1Year={lessThan1Year}
            lastUpdated={lastUpdated}
          />
          <DegreesOffered
            majors={majors}
            lastUpdated={lastUpdated}
            programsOnline={programsOnline}
          />
          <Placement placement={placement} lastUpdated={lastUpdated} />
        </PodBanner>
        {facultyProfiles && (
          <div>
            {facultyProfiles.map((pr, index) => (
              <Profile
                key={pr.persons_name}
                profile={pr}
                showHeading={index === 0}
                collegeName={collegeName}
              />
            ))}
          </div>
        )}
        {programProfiles &&
          programProfiles.map((pr, index) => (
            <Profile
              key={pr.persons_name}
              profile={pr}
              showHeading={index === 0}
              collegeName={collegeName}
            />
          ))}
        {!isEmpty(topAreasOfStudy) && (
          <TopAreasOfStudy
            topAreasOfStudy={topAreasOfStudy}
            lastUpdatedMajor={lastUpdatedMajor}
            topAreasOfStudyTitle={topAreasOfStudyTitle}
          />
        )}
        <MajorsMinors
          majors={groupMajors(majors)}
          lastUpdatedMajor={lastUpdatedMajor}
          minors={minors}
          getDegreesOfferedFilter={getDegreesOfferedFilter}
          setDegreesOfferedFilter={setDegreesOfferedFilter}
        />
        <StudyOptions studyOptions={studyOptions} lastUpdated={lastUpdated} />
      </div>
    );
  }
}

export default withHostContext(StudiesMenu);
